export enum EBackgroundPattern {
  pattern1 = 'pattern1',
}
